
  <div fxLayout="row" fxLayoutAlign="center center">
    <mat-card fxFlex>
      <mat-card-header>
        <mat-card-title>Legal Agreement</mat-card-title>
        <mat-card-subtitle>{{latestVersion}}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div fxLayout="row" fxLayoutAlign="center center">
          <div class="pdf-container" style="width: 100%;height:60vh;">
            <app-pdf-viewer *ngIf="!!latestAgreementUrl" pdfUrl="{{latestAgreementUrl}}" embedMode="SIZED_CONTAINER"></app-pdf-viewer>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px" class="p-t-20">
          <mat-checkbox [(ngModel)]="acceptLicenseAgreement">Accept License Agreement</mat-checkbox>
          <button disabled="{{!acceptLicenseAgreement}}" mat-flat-button color="primary"(click)="continueClick()"><mat-icon>done</mat-icon> Continue
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
